import { Box, Button, HStack, Text, VStack } from "@chakra-ui/react";
import { File, UploadCloud, X } from "lucide-react";
import { useEffect, useRef } from "react";

export function FileDropzone({
  file,
  onChange,
  accept,
  hint,
}: {
  file: File | null;
  onChange: (file: File | null) => void;
  accept: string;
  hint: string;
}) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!file && inputRef.current) inputRef.current.value = "";
  }, [file]);

  return (
    <Box
      px={4}
      py={file ? 3 : 4}
      border="2px dashed"
      borderColor={file ? "palomma.400" : "gray.300"}
      borderRadius="lg"
      bg={file ? "palomma.50" : "gray.50"}
      cursor="pointer"
      transition="all 0.2s"
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        if (e.dataTransfer.files[0]) onChange(e.dataTransfer.files[0]);
      }}
      onClick={() => inputRef.current?.click()}
      _hover={{ borderColor: "palomma.400", bg: "palomma.50" }}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        style={{ display: "none" }}
        onChange={(e) => {
          if (e.target.files?.[0]) onChange(e.target.files[0]);
        }}
      />
      {file ? (
        <HStack justify="space-between" w="full" gap={3}>
          <HStack gap={3} minW={0}>
            <Box p={2} bg="white" borderRadius="md">
              <File size={18} color="#8e5cff" />
            </Box>
            <VStack gap={0} align="start" minW={0}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color="gray.800"
                truncate
              >
                {file.name}
              </Text>
              <Text fontSize="xs" color="gray.500">
                Haz clic para cambiar el archivo
              </Text>
            </VStack>
          </HStack>
          <Button
            variant="ghost"
            size="xs"
            onClick={(e) => {
              e.stopPropagation();
              onChange(null);
            }}
          >
            <X size={16} />
          </Button>
        </HStack>
      ) : (
        <HStack justify="center" gap={3} py={1}>
          <UploadCloud size={22} color="#8e5cff" />
          <VStack gap={0} align="start">
            <Text fontSize="sm" fontWeight="medium" color="gray.700">
              Haz clic o arrastra tu archivo aquí
            </Text>
            <Text fontSize="xs" color="gray.500">
              {hint}
            </Text>
          </VStack>
        </HStack>
      )}
    </Box>
  );
}
